package com.milta.core.localization.translations.pl

import com.milta.core.localization.RouteStrings
import com.milta.core.localization.RouteStringsCoreImpl
import com.milta.core.localization.RouteStringsExtraImpl

internal val Route = RouteStrings(
    core = RouteStringsCoreImpl(
    manualDeliveryTitle = "Nowa dostawa",
    manualDeliverySubtitle = "Dodaj dostawę do trasy",
    recipientNameLabel = "Nazwa odbiorcy",
    addressLabel = "Adres",
    phoneNumberLabel = "Telefon",
    deliveryTimeLimitLabel = "Limit czasu",
    optionalSuffix = "(opcjonalnie)",
    submitButton = "Dodaj i kontynuuj",
    saveEditedDeliveryButton = "Zapisz zmianę",
    deliveryCreated = "Dostawa dodana",
    errorRecipientNameRequired = "Nazwa odbiorcy jest wymagana",
    errorRecipientNameTooLong = "Nazwa jest za długa (maks. 150 znaków)",
    errorAddressRequired = "Adres jest wymagany",
    errorAddressTooLong = "Adres jest za długi (maks. 255 znaków)",
    errorPhoneTooLong = "Telefon jest za długi (maks. 20 znaków)",
    errorDuplicateDelivery = "Ta dostawa jest już na liście (ten sam odbiorca i adres)",
    errorRouteNotFound = "Nie znaleziono trasy",
    errorForbidden = "Nie masz uprawnień do edycji tej trasy",
    errorValidation = "Sprawdź wprowadzone pola",
    errorGeneric = "Coś poszło nie tak. Spróbuj ponownie.",
    errorRouteNotInProgress = "Ta trasa nie jest już w toku. Nie można dodać dostawy.",
    unknownRecipientLabel = "Nieznany",
    driverHomeTitle = "Moja trasa",
    driverModeBadge = "Tryb kierowcy",
    routeStatusScheduled = "Zaplanowana",
    routeStatusInProgress = "W toku",
    routeStatusCompleted = "Zakończona",
    routeStatusPartial = "Częściowa",
    driversDepartedOne = "wyruszył",
    driversDepartedMany = "wyruszyło",
    driversFinishedOne = "zakończył",
    driversFinishedMany = "zakończyło",
    stopsDeliveredLabel = "Dostarczone",
    stopsInProgressLabel = "W trakcie",
    stopsTodoLabel = "Do zrobienia",
    stopsFailedLabel = "Nieudane",
    stopsUntreatedLabel = "Nieobsłużone",
    stopsCountLabel = "przystanki",
    startRouteButton = "Rozpocznij trasę",
    noRouteTitle = "Brak trasy",
    noRouteSubtitle = "Obecnie nie masz przypisanej żadnej trasy.",
    noRoutePastSubtitle = "Nie miałeś przypisanej żadnej trasy na ten dzień.",
    routeInProgressTitle = "Trasa w toku",
    routeCompletedTitle = "Trasa zakończona",
    addStopButton = "Dodaj przystanek",
    errorConflict = "Trasa została już rozpoczęta lub zakończona.",
    greetingPrefix = "Cześć",
    routeOfTheDayLabel = "DZISIEJSZA TRASA",
    noOtherRouteLabel = "Brak innych zaplanowanych tras",
    routeLabel = "Trasa",
    importMenuTitle = "Importuj dostawy",
    importMenuSubtitle = "Kilka trybów do łączenia — wybierz źródło",
    importModeScanDocumentTitle = "Skanuj dokument",
    importModeScanDocumentDesc = "Zrób zdjęcie listy lub etykiety paczki",
    importModePdfTitle = "Importuj plik PDF",
    importModePdfDesc = "Listy przewozowe, zeskanowany plik",
    importModeExcelTitle = "Excel / CSV",
    importModeExcelDesc = "Twój własny format — kolumny wykrywane automatycznie",
    importModeManualTitle = "Wprowadzanie ręczne",
    importModeManualDesc = "Imię, adres, telefon, godzina graniczna",
    photoSourceSheetTitle = "Jak chcesz dodać zdjęcie?",
    photoSourceTakePhoto = "Zrób zdjęcie",
    photoSourceChooseGallery = "Wybierz z galerii",
    photoSourceChooseFiles = "Wybierz obraz z plików",
    createRouteTitle = "Utwórz trasę",
    routeCardDetailLabel = "Szczegóły",
    importReviewTitle = "Sprawdź zaimportowane dostawy",
    importReviewMissingGpsWarning = "Brak współrzędnych GPS",
    importReviewRetryGeocodeAction = "Ponów geokodowanie",
    createRouteEmptyDrivers = "Brak kierowców w Twoim zespole",
    editDeliveriesAction = "Edytuj",
    moreDeliveriesLabel = "więcej",
    addDeliveriesAction = "Dodaj dostawy",
    manualEntryAddedConfirmPrefix = "Dostawa dodana:",
    manualEntryMergedConfirmPrefix = "Paczka dodana do istniejącej dostawy",
    manualEntryAddedCountLabel = "Dodane dostawy",
    manualEntryFinishButton = "Zakończ",
    optimizeRouteButton = "Optymalizuj trasę",
    createRouteButtonNoOptimize = "Utwórz trasę",
    errorNoEnterprise = "Brak firmy powiązanej z Twoim kontem",
    errorDriverNotFound = "Nie znaleziono kierowcy",
    errorNoDeliveries = "Dodaj co najmniej jedną dostawę przed optymalizacją trasy",
    errorOptimizationUnavailable = "Usługa optymalizacji jest tymczasowo niedostępna.",
    errorGeocodingFailed = "Nie udało się zlokalizować niektórych adresów dostawy. Popraw adres i spróbuj ponownie.",
    dispatchTitle = "Optymalizacja",
    optimizedSuccessTitle = "Trasa zoptymalizowana!",
    optimizedSuccessSubtitleSuffix = "przystanków uporządkowanych dla najkrótszej trasy",
    stopsStatLabel = "Przystanki",
    stopDetailTitlePrefix = "Przystanek",
    stopStatusCurrentLabel = "W toku",
    stopStatusUpcomingLabel = "Nadchodzący",
    stopStatusDeliveredLabel = "Dostarczono",
    stopStatusFailedLabel = "Niepowodzenie",
    stopRecipientLabel = "Odbiorca",
    callActionLabel = "Zadzwoń",
    noPhoneLabel = "Brak podanego telefonu",
    packagesCountLabel = "paczek",
    navigateButton = "Nawiguj",
    navigationUnavailableUnverifiedAddress = "Adres niezweryfikowany: nawigacja niedostępna dla tego przystanku.",
    deadlineBeforePrefix = "Przed",
    deadlinePastSuffix = "po terminie",
    validateStopAction = "Zatwierdź ten przystanek",
    teamDashboardTitle = "Trasy",
    todayDateLabel = "Dzisiaj",
    statRoutesLabel = "Trasy",
    statDeliveriesLabel = "Dostawy",
    statCompletedLabel = "Zakończone",
    teamSectionTitle = "Zespół",
    routeStartedAtPrefix = "Rozpoczęto o",
    routeCompletedAtPrefix = "Zakończono o",
    routeNotStartedLabel = "Nierozpoczęta",
    emptyTeamRoutesTitle = "Brak trasy tego dnia",
    emptyTeamRoutesSubtitle = "Żaden kierowca zespołu nie ma zaplanowanej trasy na ten dzień.",
    errorInvalidDate = "Nieprawidłowa data",
    routeDetailTitle = "Szczegóły trasy",
    driverEyebrowLabel = "Kierowca",
    failedDeliveryTag = "Dostawa nieudana",
    driverLoadingCheckTitle = "Weryfikacja załadunku",
    loadingCheckInstructionText = "Sprawdź, czy wszystkie przewidziane paczki są załadowane do pojazdu przed wyruszeniem.",
    expectedPackagesLabel = "paczek przewidzianych na tę trasę",
    confirmLoadCheckboxPrefix = "Załadowałem",
    confirmLoadCheckboxSuffix = "paczek przewidzianych na tę trasę",
    reportDiscrepancyToggleLabel = "Zgłoś rozbieżność",
    discrepancyNotePlaceholder = "Np.: załadowałem 9 paczek zamiast 11…",
    discrepancyNoteTooLong = "Notatka zbyt długa — maksymalnie 500 znaków.",
    undeliveredStopsSectionTitle = "Paczki nieodebrane — usuń z trasy",
    removedStopNoticePrefix = "„",
    removedStopNoticeMiddle = "” usunięto z trasy — 1 przystanek mniej",
    remainingStopsSuffix = "pozostało",
    confirmAndStartButton = "Potwierdź i rozpocznij trasę",
    loadingOnBehalfOfLabel = "Na zlecenie",
    loadingExpectedLabel = "Planowany załadunek",
    loadingQuestionTitle = "Czy załadowałeś wszystkie paczki?",
    loadingAllLoadedPrefix = "Tak, wszystkie",
    loadingAllLoadedSuffix = "paczki są na pokładzie",
    loadingIncompleteOption = "Niekompletny załadunek",
    loadingIncompleteHint = "Usuwam odpowiednie przystanki lub uzasadniam",
    loadingIncompleteRemoveLabel = "I/lub usuń niezaładowane przystanki",
    slideToStartLabel = "Przesuń, aby rozpocząć",
    completeRouteButton = "Zakończ trasę",
    completeRouteDialogTitle = "Zakończyć trasę?",
    completeRouteDialogPendingCountSuffix = "dostaw nie zostało jeszcze zrealizowanych",
    completeRouteDialogPendingNote = "Zostaną oznaczone jako nieudane z podanym poniżej powodem. Odpowiadasz za te nieobsłużone dostawy.",
    completeRouteDialogBody = "Ta czynność jest ostateczna: trasa przejdzie do statusu „Zakończona” i nie będzie można jej już modyfikować.",
    completeRouteDialogBodyAllTreated = "Wszystkie dostawy zostały zrealizowane. Trasa przejdzie do statusu „Zakończona” i nie będzie można jej już modyfikować.",
    completeRouteDialogConfirm = "Zakończ",
    completeRouteDialogReasonLabel = "Powód (opcjonalny)",
    completeRouteDialogReasonPlaceholder = "Wyjaśnij, dlaczego te dostawy nie zostały obsłużone…",
    completeRouteDialogNoReasonWarning = "Jeśli nie podasz powodu, pozostałe przystanki zostaną zapisane jako niedostarczone z winy przewoźnika.",
    routeCompletedMessage = "Trasa zakończona.",
    stopStatusUntreatedLabel = "Nieobsłużona",
    errorCompleteRouteStatusConflict = "Ta trasa nie może zostać zakończona w obecnym stanie.",
    errorCompleteRoutePendingStopsConflict = "Niektóre dostawy nadal oczekują. Potwierdź, aby mimo to zakończyć.",
    stopSearchOpenAction = "Szukaj przystanku",
    stopSearchCloseAction = "Zamknij wyszukiwanie",
    stopSearchPlaceholder = "Nazwisko, adres lub telefon",
    stopSearchClearTextAction = "Wyczyść tekst",
    stopSearchResultCount = "Przystanki: %1 z %2",
    stopSearchResultCountOne = "Przystanki: 1 z %1",
    stopSearchEmptyTitle = "Brak pasujących przystanków",
    stopSearchEmptyHint = "Sprawdź pisownię lub wyszukaj według adresu lub telefonu.",
    stopSearchClearAction = "Wyczyść wyszukiwanie",
    stopPositionLabel = "nr %1",
    ),
    extra = RouteStringsExtraImpl(
    packageCountFieldLabel = "Liczba paczek",
    reoptimizeSuccessTitle = "Trasa zoptymalizowana ponownie",
    backToRouteButton = "Powrót do trasy",
    routeBatchMultiDriverLink = "Podziel między kilku kierowców",
    routeBatchSelectTitle = "Podziel trasę",
    routeBatchDeliveriesReadyLabel = "dostaw gotowych do podziału",
    routeBatchDriversSectionTitle = "Kierowcy",
    routeBatchDriversSelectedSuffix = "wybranych kierowców",
    routeBatchOptimizeToggleTitle = "Optymalizuj trasę",
    routeBatchOptimizeToggleHelp = "RoutaR dzieli i porządkuje przystanki według odległości. Wyłączone: proste równe rozdzielenie według liczby przystanków, bez obliczania trasy.",
    routeBatchSubmitButtonPrefix = "Podziel między",
    routeBatchDriversWord = "kierowców",
    routeBatchOptimizationUnavailable = "Usługa optymalizacji jest tymczasowo niedostępna. Trasa nie została utworzona — sprawdź połączenie i spróbuj ponownie albo wyłącz „Optymalizuj trasę”, aby uzyskać natychmiastowy prosty podział.",
    routeBatchPreviewTitle = "Podgląd podziału",
    routeBatchPreviewEyebrowMiddle = "dostaw podzielonych między",
    routeBatchPreviewEyebrowSuffix = "kierowców",
    routeBatchStopsChipSuffix = "przystanków",
    routeBatchDistanceLabel = "Odległość",
    routeBatchDurationLabel = "Szacowany czas",
    routeBatchDistanceNotCalculated = "Nieobliczona",
    routeBatchOptimizeDisabledBanner = "Optymalizacja wyłączona: równy podział według liczby przystanków, bez obliczania odległości ani kolejności.",
    routeBatchReoptimizeButton = "Zoptymalizuj ponownie",
    routeBatchDispatchButton = "Potwierdź i wyślij",
    errorRouteBatchAlreadyDispatched = "Ta partia tras została już wysłana do kierowców — nie można jej już zmienić.",
    routeBatchDispatchedTitle = "Trasy wysłane!",
    routeBatchDispatchedSubtitleSuffix = "kierowców powiadomionych jednocześnie, każdy z własną zaplanowaną trasą.",
    routeBatchStatRoutesLabel = "Trasy",
    routeBatchStatDeliveriesLabel = "Dostawy",
    routeBatchStatusLabel = "Status",
    routeBatchStatusDispatchedValue = "Wysłana",
    routeBatchSentAtLabel = "Wysłano dnia",
    routeBatchPerDriverTitle = "Szczegóły dla każdego kierowcy",
    routeBatchDriverScheduledStatus = "Zaplanowana",
    routeBatchBackToHomeButton = "Powrót do ekranu głównego",
    errorTooManyDrivers = "Nie można wybrać więcej niż 50 kierowców naraz.",
    errorTooManyDeliveries = "Partia nie może przekroczyć 500 dostaw.",
    createRouteFabLabel = "Nowa trasa",
    createOwnRouteButtonLabel = "Utwórz / zoptymalizuj moją trasę",
    createOwnRouteTitle = "Utwórz moją trasę",
    createOwnRouteDeliveriesCountSuffix = "dostaw gotowych",
    stopStatusEnRouteLabel = "W drodze",
    yesterdayDateLabel = "Wczoraj",
    periodPastLabel = "Przeszłość",
    periodTomorrowLabel = "Jutro",
    viewRouteButton = "Zobacz trasę",
    viewButton = "Zobacz",
    noRouteTomorrowTitle = "Nic nie zaplanowano na jutro",
    noRouteTomorrowSubtitle = "Zaplanuj trasę z wyprzedzeniem, aby była gotowa już jutro rano.",
    planRouteButtonLabel = "Zaplanuj trasę",
    myRoutesTodayTitle = "Twoje dzisiejsze trasy",
    myRoutesTitle = "Twoje trasy",
    weekdayShortNames = listOf("Pon", "Wt", "Śr", "Czw", "Pt", "Sob", "Nie"),
    weekdayFullNames = listOf("Poniedziałek", "Wtorek", "Środa", "Czwartek", "Piątek", "Sobota", "Niedziela"),
    monthNames = listOf("styczeń", "luty", "marzec", "kwiecień", "maj", "czerwiec", "lipiec", "sierpień", "wrzesień", "październik", "listopad", "grudzień"),
    statRoutesTodayLabel = "Trasy dzisiaj",
    statStopsTodayLabel = "Przystanki dzisiaj",
    statOnTimeLabel = "Na czas dzisiaj",
    statAvgProgressLabel = "Średni postęp",
    inProgressSectionTitle = "W trakcie",
    upcomingSectionTitle = "Nadchodzące",
    doneSectionTitle = "Zakończone",
    seeAllLabel = "Zobacz wszystkie",
    continueRouteButton = "Kontynuuj trasę",
    detailsLinkLabel = "Szczegóły",
    deliveryProofTitle = "Potwierdź dostawę",
    deliveryProofStatusSectionLabel = "Status dostawy",
    deliveryProofPhotoSectionLabel = "Zdjęcie potwierdzające",
    deliveryProofPhotoHint = "Wymagane do potwierdzenia",
    deliveryProofTakePhotoCta = "Zrób zdjęcie",
    deliveryProofRetakePhotoCta = "Zrób zdjęcie ponownie",
    deliveryProofRetakeChipLabel = "Ponów",
    deliveryProofCommentSectionLabel = "Komentarz",
    failureReasonRouteClosedByDriver = "Trasa zamknięta przez kierowcę: przystanek niedostarczony z winy przewoźnika.",
    deliveryProofCommentRequiredSuffix = "wymagany w przypadku niepowodzenia",
    deliveryProofCommentPlaceholderOptional = "Opcjonalnie — szczegóły dotyczące dostawy…",
    deliveryProofCommentPlaceholderRequired = "Wyjaśnij powód niepowodzenia…",
    deliveryProofCommentRequiredError = "Komentarz jest wymagany w przypadku nieudanej dostawy",
    deliveryProofSubmitButton = "Potwierdź dostawę",
    deliveryProofErrorInvalidPhoto = "Zdjęcie nieczytelne lub format nieobsługiwany. Zrób zdjęcie ponownie i spróbuj jeszcze raz.",
    deliveryProofAlreadyProcessedBanner = "Ten przystanek został już przetworzony i nie można go już zmienić.",
    proofPhotoViewerDownloadLabel = "Pobierz",
    proofPhotoViewerCloseLabel = "Zamknij",
    proofPhotoDownloadedMessage = "Zdjęcie zapisane w galerii.",
    proofPhotoDownloadErrorMessage = "Nie udało się zapisać zdjęcia.",
    deliveryConfirmTitle = "Dostawa potwierdzona",
    deliveryConfirmSuccessTitle = "Dostawa potwierdzona",
    deliveryConfirmSuccessSubtitle = "Potwierdzenie zostało zapisane dla tego przystanku.",
    deliveryConfirmFailedTitle = "Niepowodzenie zarejestrowane",
    deliveryConfirmFailedSubtitle = "Komentarz i zdjęcie zostały przesłane do menedżera.",
    deliveryConfirmRouteCompletedTitle = "Trasa zakończona!",
    deliveryConfirmRouteCompletedSubtitle = "Wszystkie przystanki zostały obsłużone.",
    deliveryConfirmValidatedAtLabel = "Potwierdzono dnia",
    deliveryConfirmNextStopEyebrowPrefix = "Następny przystanek",
    deliveryConfirmGoToNextStopButton = "Przejdź do następnego przystanku",
    deliveryConfirmAllDoneMessage = "To był ostatni przystanek trasy — pamiętaj, aby ją zakończyć.",
    offlineBannerTitle = "Offline",
    offlineBannerRouteSubtitle = "Twoje potwierdzenia zostaną wysłane po powrocie sieci",
    offlineBannerValidateSubtitle = "zostanie zapisane lokalnie",
    offlineSyncingBannerTitle = "Synchronizacja w toku",
    offlineSyncingSubtitleSuffix = "dostaw wysłanych",
    offlineRetryBannerTitle = "Synchronizacja nieudana",
    offlineRetryBannerSubtitle = "kolejna próba przy następnym połączeniu z siecią",
    offlineSyncSuccessToastSuffix = "dostaw zsynchronizowanych pomyślnie",
    offlineQueuedBadgePendingLabel = "Oczekuje na wysłanie",
    offlineQueuedBadgeSyncingLabel = "Wysyłanie",
    offlineQueuedBadgeFailedLabel = "Niepowodzenie — zaplanowano ponowną próbę",
    offlineQueuedBadgeConflictLabel = "Już obsłużone gdzie indziej",
    offlineDismissConflictAction = "Odrzuć",
    offlineValidatedLocallyAtPrefix = "potwierdzono lokalnie o",
    offlineAddStopRequiresConnectionSuffix = "(wymaga połączenia)",
    deliveryProofOfflineSubmitButton = "Zapisz (synchronizacja później)",
    deliveryProofSavedLocallyTitle = "Zapisano lokalnie",
    deliveryProofSavedLocallySubtitle = "Ta dostawa zostanie automatycznie wysłana po przywróceniu połączenia.",
    routeScheduledBannerTitle = "Trasa jeszcze nie rozpoczęta",
    routeScheduledBannerSubtitle = "Rozpocznij trasę, aby móc zatwierdzić dostawę.",
    geocodeIssueTag = "Adres nie zlokalizowany",
    regeocodeAction = "Spróbuj ponownie zgeolokalizować",
    regeocodeSuccessMessage = "Adresy zaktualizowane",
    dashboardTitle = "Dashboard",
    viewAllAction = "Zobacz wszystkie",
    deleteRouteDialogTitle = "Usunąć trasę?",
    deleteRouteDialogMessage = "Ta trasa zostanie trwale usunięta. Tej czynności nie można cofnąć.",
    errorRouteDeleteConflict = "Usunięcie niedostępne: trasa jest w trakcie realizacji.",
    errorDriverHasActiveRoute = "Inna trasa jest już w trakcie realizacji. Zakończ ją, zanim rozpoczniesz tę.",
    routeBatchNoStopsTag = "Brak przystanków",
    routeBatchNoStopsDialogTitle = "Kierowca bez przystanków",
    routeBatchNoStopsDialogMessage = "Co najmniej jeden kierowca nie ma przypisanego żadnego przystanku. Mimo to otrzyma pustą trasę, jeśli nie zostanie usunięty z tej partii. Wysłać mimo to?",
    routeBatchAddressesToReviewTag = "adres(y) do sprawdzenia",
    otherDeliveriesInImportLabel = "Inne dostawy z tego importu",
    proofPhotoUnavailableLabel = "Zdjęcie niedostępne",
    deliveryProofPhotoOptionalSectionLabel = "Zdjęcie (opcjonalne)",
    proofWithoutPhotoLabel = "Bez zdjęcia",
    removeStopDialogTitle = "Usunąć ten przystanek?",
    removeStopDialogMessage = "„{name}” ({count} paczek) zostanie usunięty z trasy. Tej czynności nie można cofnąć.",
    deliveryRemovedMessage = "Dostawa usunięta",
    undoAction = "Cofnij",
    callLaunchFailed = "Nie można rozpocząć połączenia na tym urządzeniu",
    keepDraftsDialogTitleOne = "Zachować dostawę?",
    keepDraftsDialogTitleMany = "Zachować {count} dostaw(y)?",
    keepDraftsDialogMessage = "Zostały wprowadzone, ale nie ma ich jeszcze na liście.",
    keepDraftsAction = "Zachowaj",
    deliveriesAddedToRouteOne = "Dodano 1 dostawę do trasy",
    deliveriesAddedToRouteMany = "Dodano {count} dostaw do trasy",
    driverJoinedTeamMessage = "{name} dołączył(a) do zespołu",
    ownRouteCreatedNotOptimizedMessage = "Trasa utworzona we wprowadzonej kolejności: optymalizacja nie była możliwa",
    draftExitTitle = "Opuścić tworzenie?",
    draftExitMessageOne = "Dodano 1 dostawę ({packages} paczek).",
    draftExitMessageMany = "Dodano {count} dostaw ({packages} paczek).",
    draftKeepAction = "Zachowaj na później",
    draftDeleteDeliveriesAction = "Usuń dostawy",
    draftContinueAction = "Kontynuuj tworzenie",
    draftSavedMessage = "Szkic zapisany",
    draftCardTitle = "Trasa w trakcie tworzenia",
    draftForDate = "na {date}",
    draftResumeAction = "Wznów",
    draftDeleteDialogTitle = "Usunąć szkic?",
    draftDeleteDialogMessageOne = "Wprowadzona dostawa ({packages} paczek) zostanie usunięta. Tej czynności nie można cofnąć.",
    draftDeleteDialogMessageMany = "{count} wprowadzonych dostaw ({packages} paczek) zostanie usuniętych. Tej czynności nie można cofnąć.",
    draftResumeImportTitle = "Wznów trwającą trasę",
    draftImportAddsHint = "Zaimportowane dostawy zostaną dodane do tego szkicu:",
    stopDeliveredAtPrefix = "Dostarczono o",
    stopFailedAtPrefix = "Niepowodzenie o",
    stopOnTimeLabel = "Na czas",
    stopLateByPrefix = "Spóźnienie",
    stopTimeLabel = "Czas",
    stopAfterStartSuffix = "po wyjeździe",
    stopAfterPreviousSuffix = "po poprzednim przystanku",
    stopDriverCommentLabel = "Komentarz kierowcy",
    stopPackagesLabel = "Paczki",
    durationHoursUnit = "godz.",
    durationMinutesUnit = "min",
    ),
)
